import React from "react";
import { Play, Square } from "lucide-react";

const ScreensaverButton = ({ isActive, onClick }) => {
  return (
    <button
      className={`screensaver-btn ${isActive ? "active" : ""}`}
      onClick={onClick}
      aria-label={isActive ? "Stop Screensaver" : "Start Screensaver"}
    >
      {isActive ? <Square size={20} /> : <Play size={20} />}
    </button>
  );
};

export default ScreensaverButton;